
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductTypeDialog extends _Ext.DialogBase<ProductTypeRow, any> {
        protected getFormKey() { return ProductTypeForm.formKey; }
        protected getIdProperty() { return ProductTypeRow.idProperty; }
        protected getLocalTextPrefix() { return ProductTypeRow.localTextPrefix; }
        protected getNameProperty() { return ProductTypeRow.nameProperty; }
        protected getService() { return ProductTypeService.baseUrl; }
        protected getDeletePermission() { return ProductTypeRow.deletePermission; }
        protected getInsertPermission() { return ProductTypeRow.insertPermission; }
        protected getUpdatePermission() { return ProductTypeRow.updatePermission; }
        protected useViewMode() { return true; }
        protected get_ExtDialogOptions() {
            let options = super.get_ExtDialogOptions();
            options.ShowDeleteButton = false;
            options.AutoFitContentArea = false;
            return options;
        }
        protected form = new ProductTypeForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.Purity);
        }
        onDialogOpen() {
            super.onDialogOpen();
            var itemtype = this.form.ItemTypeId.value;
            if (itemtype == "104")
                q.showField(this.form.Purity);
            else
                q.hideField(this.form.Purity);
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            //var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            //var oldDeleteClick = btnDelete.onClick;
            //btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            let self = this;


            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };



            return btns;
        }

        private confirmBeforeEdit(oldEvt, e) {
            if (this.hasUpdatePermission) {
                let self = this;
                var itemtype = self.form.ItemTypeId.value;
                if (itemtype != "104") {
                    q.alert('', 'Cannot Edit this Attribute!', true, 2000);
                    return;
                }
                else {
                    
                    if (!self.isEditMode())
                        return;
                    self.editClicked = true;

                    self.updateInterface();
                    self.updateTitle();

                }
            }
        }
    }
}